export default __webpack_public_path__ + "app/images/btn-toolbar-close-normal.svg";